export const MUTATION_KEYS = {
    create_goal: 'create-goal'
}

export const QUERY_KEYS = {
    goalType: 'goal-type-V3',
    goals_path: 'goals-path',
    selectedGoal: 'selected-goal-V3',
    supporters_list: 'supporters-list',
    supportersList: 'supporters-list-V3',
    goals_list: 'goals-list',
    past_goals: 'past-goals',
    supported_goals: 'supported-goals',
    broadcasts_supporters: 'broadcasts-supporters',
    hostGoals: 'host-goals-V3',
    goalsForCreator: 'goals-for-creator',
    savedGoals: 'saved-goals-v3'
}
